import { Component, OnInit } from "@angular/core"
import { SearchInfoModel } from "../../../models/searchInfo.model"
import { FacetingService } from "../../../services/faceting.service"
import { SearchingService } from "../../../services/searching.service"
import { EduComponent } from "../../../utils/eduComponent"
import { ModalRef } from "../../modal/modal-ref"

@Component({
    selector: "app-mobile-filter-modal",
    templateUrl: "./mobile-filter-modal.component.html",
    styleUrls: ["./mobile-filter-modal.component.less"],
})
export class MobileFilterModalComponent extends EduComponent implements OnInit {
    public totalCount: number = 0
    public appliedFiltersCount: number = 0
    public searchInfo: SearchInfoModel

    constructor(
        public activeModal: ModalRef,
        public searchingService: SearchingService,
        public facetingService: FacetingService
    ) {
        super()
    }

    public ngOnInit() {
        this.addSub(
            this.searchingService.resultsCount.subscribe((count) => (this.totalCount = count))
        )
        this.addSub(
            this.facetingService.filtersChanged.subscribe((data) => {
                if (data) {
                    this.appliedFiltersCount = data.length
                }
            })
        )
    }
}
